const PAIR_SYMBOL_TO_PAIR_ADDRESS = {
  // This might have changed
  USDT_USDC: "0x74c2efa722010ad7c142476f525a051084da2c42",
};

const PAIR_ADDRESS_TO_REWARDS_POOL = {
  // This might have changed
  [PAIR_SYMBOL_TO_PAIR_ADDRESS.USDT_USDC]: 6,
};

const POOL_ID_TO_REWARDS_ADDRESSES = {
  [PAIR_ADDRESS_TO_REWARDS_POOL[PAIR_SYMBOL_TO_PAIR_ADDRESS.USDT_USDC]]: ["0x2995d1317dcd4f0ab89f4ae60f3f020a4f17c7ce", "0x9c58bacc331c9aa871afd802db6379a98e80cedb"],
};

const PAIR_ADDRESS_TO_REWARDS_LENGTH = {
};

module.exports = {
  ADDRESS: "0xddcbf776df3de60163066a5dddf2277cb445e0f3",
  PAIR_SYMBOL_TO_PAIR_ADDRESS,
  POOL_ID_TO_REWARDS_ADDRESSES,
  PAIR_ADDRESS_TO_REWARDS_POOL,
  PAIR_ADDRESS_TO_REWARDS_LENGTH
};
